export default __webpack_public_path__ + "static/media/image29.5f69c7d5.png";